// Mock data for Groundhogs Environmental - Septic Solutions

export const services = [
  {
    id: 1,
    title: "New Traditional Septic Installation",
    description: "Complete traditional septic system installation engineered for Northwestern Ontario's unique soil conditions. From site evaluation to final inspection, we handle permits, excavation, and installation with precision.",
    image: "/seo-images/4z8mh8az_unnamed.webp",
    slug: "new-traditional-septic"
  },
  {
    id: 2,
    title: "Traditional Septic Replacement",
    description: "Full replacement of failing traditional septic systems. Our expert crew removes old systems and installs new, code-compliant systems designed to last decades in Northwestern Ontario's challenging climate.",
    image: "/seo-images/f69s3hj7_sep.webp",
    slug: "traditional-septic-replacement"
  },
  {
    id: 3,
    title: "New Eljen Mound System Installation",
    description: "Advanced Eljen mound system installation ideal for properties with limited space. Much smaller field size requirements reduce imported sand and site disruption. Perfect for challenging sites with high water tables and difficult soil conditions common in Northwestern Ontario.",
    image: "/seo-images/dmesnkeu_Eljen1.webp",
    slug: "eljen-mound-installation"
  },
  {
    id: 4,
    title: "Eljen Mound System Replacement",
    description: "Complete Eljen mound system replacement with the latest technology. Smaller footprint means less disruption and reduced sand import. We specialize in upgrading from traditional systems to advanced Eljen solutions that handle Northwestern Ontario's freeze-thaw cycles.",
    image: "/seo-images/o3xatnja_Eljen_2.webp",
    slug: "eljen-replacement"
  }
];

export const serviceAreas = [
  {
    name: "Thunder Bay",
    description: "Headquarters - 415 - Unit B, Fort William Road",
    features: ["Clay soil expertise", "Extreme weather solutions", "Local headquarters"],
    isHQ: true
  },
  {
    name: "Kenora",
    description: "Serving Kenora & Lake of the Woods Region",
    features: ["Rocky terrain specialists", "Lakefront properties", "Cottage installations"]
  },
  {
    name: "Dryden",
    description: "Serving Dryden & Area",
    features: ["Rural installations", "Large property systems", "Permit assistance"]
  },
  {
    name: "Fort Frances",
    description: "Serving Fort Frances & Rainy River District",
    features: ["Border region coverage", "Seasonal property experts", "Year-round service"]
  },
  {
    name: "Atikokan",
    description: "Serving Atikokan & Surrounding Townships",
    features: ["Remote installations", "Mining area geology", "Challenging terrain"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Thunder Bay, ON",
    text: "Groundhogs installed our new Eljen system last fall. Professional crew, clean worksite, and they handled all the permits. System works perfectly!",
    rating: 5
  },
  {
    id: 2,
    name: "Robert K.",
    location: "Kenora, ON",
    text: "Had our old septic replaced with a new traditional system. The team was efficient, knowledgeable, and completed the job faster than expected.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer L.",
    location: "Dryden, ON",
    text: "Best septic company in Northwestern Ontario. They explained everything clearly and the installation was flawless. Highly recommend!",
    rating: 5
  }
];

export const stats = [
  { number: "1200+", label: "Installs Completed" },
  { number: "15+", label: "Years Experience" },
  { number: "99%", label: "Client Satisfaction" },
  { number: "10+", label: "Expert Technicians" }
];

export const videoProjects = [
  {
    id: 1,
    title: "Traditional Septic Installation Process",
    description: "Watch our crew install a complete traditional septic system from excavation to final grading.",
    thumbnail: "/seo-images/4z8mh8az_unnamed.webp"
  },
  {
    id: 2,
    title: "Eljen Mound System Construction",
    description: "See how we build advanced Eljen mound systems for challenging Northwestern Ontario sites.",
    thumbnail: "/seo-images/nfr15n0v_Eljen_3.webp"
  },
  {
    id: 3,
    title: "System Replacement Time-Lapse",
    description: "Complete septic replacement from start to finish – precision and efficiency in action.",
    thumbnail: "/seo-images/f69s3hj7_sep.webp"
  }
];

export const geoPages = [
  // Thunder Bay Core
  { city: "Thunder Bay", slug: "thunder-bay", region: "Thunder Bay" },
  
  // Immediately Surrounding Thunder Bay
  { city: "Murillo", slug: "murillo", region: "Thunder Bay Area" },
  { city: "Kakabeka Falls", slug: "kakabeka-falls", region: "Thunder Bay Area" },
  { city: "Oliver Paipoonge", slug: "oliver-paipoonge", region: "Thunder Bay Area" },
  { city: "Shuniah", slug: "shuniah", region: "Thunder Bay Area" },
  { city: "Nolalu", slug: "nolalu", region: "Thunder Bay Area" },
  { city: "Rosslyn", slug: "rosslyn", region: "Thunder Bay Area" },
  { city: "Pass Lake", slug: "pass-lake", region: "Thunder Bay Area" },
  { city: "Pearl", slug: "pearl", region: "Thunder Bay Area" },
  { city: "Savanne", slug: "savanne", region: "Thunder Bay Area" },
  { city: "Slate River", slug: "slate-river", region: "Thunder Bay Area" },
  { city: "Kaministiquia", slug: "kaministiquia", region: "Thunder Bay Area" },
  { city: "Conmee", slug: "conmee", region: "Thunder Bay Area" },
  { city: "Gillies", slug: "gillies", region: "Thunder Bay Area" },
  { city: "O'Connor", slug: "oconnor", region: "Thunder Bay Area" },
  
  // North Shore & East
  { city: "Nipigon", slug: "nipigon", region: "North Shore" },
  { city: "Red Rock", slug: "red-rock", region: "North Shore" },
  { city: "Dorion", slug: "dorion", region: "North Shore" },
  { city: "Schreiber", slug: "schreiber", region: "North Shore" },
  { city: "Terrace Bay", slug: "terrace-bay", region: "North Shore" },
  { city: "Marathon", slug: "marathon", region: "North Shore" },
  
  // Northwestern Ontario
  { city: "Kenora", slug: "kenora", region: "Northwestern Ontario" },
  { city: "Dryden", slug: "dryden", region: "Northwestern Ontario" },
  { city: "Fort Frances", slug: "fort-frances", region: "Northwestern Ontario" },
  { city: "Atikokan", slug: "atikokan", region: "Northwestern Ontario" },
  { city: "Red Lake", slug: "red-lake", region: "Northwestern Ontario" },
  { city: "Sioux Lookout", slug: "sioux-lookout", region: "Northwestern Ontario" },
  { city: "Ignace", slug: "ignace", region: "Northwestern Ontario" }
];

export const companyInfo = {
  name: "Groundhogs™ Environmental - Septic Solutions",
  phone: "1-888-907-3777",
  email: "hello@groundhogs.ca",
  address: {
    street: "415 - Unit B, Fort William Road",
    city: "Thunder Bay",
    province: "Ontario",
    postalCode: "P7B 2Z5"
  },
  serviceArea: "Northwestern Ontario"
};

export const blogPosts = [
  {
    id: 1,
    title: "How Much Does Septic Installation Cost in Thunder Bay? [2025 Complete Guide]",
    slug: "septic-installation-cost-thunder-bay-2025",
    excerpt: "Comprehensive breakdown of septic installation costs in Thunder Bay including traditional systems ($25K-$60K) and Eljen mound systems ($20K-$50K). Learn what affects pricing and how to budget.",
    author: "Groundhogs Environmental",
    date: "2025-01-15",
    image: "/seo-images/4z8mh8az_unnamed.webp",
    category: "Pricing & Costs",
    readTime: "8 min read"
  },
  {
    id: 2,
    title: "Traditional vs Eljen Septic Systems: Which is Right for Your Thunder Bay Property?",
    slug: "traditional-vs-eljen-septic-systems-thunder-bay",
    excerpt: "Detailed comparison of traditional septic systems and advanced Eljen mound systems. Learn about space requirements, costs, soil conditions, and which system works best for Northwestern Ontario properties.",
    author: "Groundhogs Environmental",
    date: "2025-01-10",
    image: "/seo-images/dmesnkeu_Eljen1.webp",
    category: "System Comparison",
    readTime: "10 min read"
  },
  {
    id: 3,
    title: "3-Day Average Septic Installations: How Groundhogs Does It So Fast",
    slug: "fast-septic-installation-1-3-days-thunder-bay",
    excerpt: "Discover how we've systemized septic installations to complete in about 3 days on average - much faster than the 5-7 day industry standard. Learn our process and why speed doesn't compromise quality.",
    author: "Groundhogs Environmental",
    date: "2025-01-05",
    image: "/seo-images/f69s3hj7_sep.webp",
    category: "Installation Process",
    readTime: "6 min read"
  },
  {
    id: 4,
    title: "Septic Permit Process in Thunder Bay: Complete 2025 Guide",
    slug: "septic-permit-process-thunder-bay-complete-guide",
    excerpt: "Everything you need to know about septic permits in Thunder Bay including Ontario Building Code requirements, Ministry of Environment approvals, and how our 100% approval rate saves you headaches.",
    author: "Groundhogs Environmental",
    date: "2025-01-02",
    image: "/seo-images/jgz2o8et_sep1.webp",
    category: "Permits & Regulations",
    readTime: "9 min read"
  },
  {
    id: 5,
    title: "Signs You Need Septic Replacement in Northwestern Ontario",
    slug: "signs-need-septic-replacement-northwestern-ontario",
    excerpt: "Learn the warning signs that indicate it's time for septic replacement including slow drains, odors, soggy drain fields, and system age. Know when to call for an evaluation.",
    author: "Groundhogs Environmental",
    date: "2024-12-28",
    image: "/seo-images/o3xatnja_Eljen_2.webp",
    category: "Maintenance & Repair",
    readTime: "7 min read"
  }
];